import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";

// --- MUDANÇA 1: Importar o fetchToken ---
// (Ajuste o caminho se o seu arquivo de Auth não estiver na mesma pasta)
import { fetchToken } from "./Auth";

function EstatisticasProjeto() {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [projeto, setProjeto] = useState(null);
  const [valorGasto, setValorGasto] = useState(0);

  useEffect(() => {
    const fetchDados = async () => {
      try {
        // 1. Buscar Projeto (Sem alterações)
        const resProjeto = await axios.get(
          `/api/projetocompleto/${id}`
        );
        if (
          resProjeto.data.Status === "Success" &&
          resProjeto.data.Result.length > 0
        ) {
          setProjeto(resProjeto.data.Result[0]);
        } else {
          throw new Error("Projeto não encontrado");
        }

        // --- MUDANÇA 2: Buscar dados do CRONOGRAMA em vez de SERVIÇOS ---
        try {
          // A rota /cronograma é protegida, precisamos do token
          const token = fetchToken();
          if (!token) {
            throw new Error("Token de autenticação não encontrado.");
          }

          const resCronograma = await axios.get(
            `/api/cronograma/${id}`,
            {
              headers: { Authorization: `Bearer ${token}` }, // Envia o token
            }
          );

          const itensDoCronograma = resCronograma.data || [];

          // Calcula o valor gasto somando todas as parcelas (valor_simples)
          // de todos os itens do cronograma.
          const somaTotalGasto = itensDoCronograma.reduce((accItens, item) => {
            const parcelas = item.mensal || [];
            const somaParcelasDoItem = parcelas.reduce(
              (accParcelas, parcela) => {
                return accParcelas + parseFloat(parcela.valor_simples || 0);
              },
              0
            );
            return accItens + somaParcelasDoItem;
          }, 0); // O valor inicial do acumulador é 0

          setValorGasto(somaTotalGasto);
        } catch (cronogramaErr) {
          console.error(
            "Erro ao buscar dados do cronograma:",
            cronogramaErr.message
          );
          // Se falhar (ex: sem token), o valor gasto continua 0
          setValorGasto(0);
        }
        // --- FIM DA MUDANÇA 2 ---
      } catch (error) {
        console.error("Erro ao buscar dados do projeto:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDados();
  }, [id]);

  // Função para calcular progresso (sem alterações)
  const calcularProgressoEtapa = (inicio, fim, situacao) => {
    if (!inicio || !fim) return 0;

    const hoje = new Date();
    const dataInicio = new Date(inicio);
    const dataFim = new Date(fim);

    if ((situacao || "").toLowerCase() === "concluído") return 100;
    if (hoje < dataInicio) return 0;
    if (hoje > dataFim) return 100;

    const totalDias = (dataFim - dataInicio) / (1000 * 3600 * 24);
    if (totalDias <= 0) return 100;

    const diasPassados = (hoje - dataInicio) / (1000 * 3600 * 24);

    return Math.round((diasPassados / totalDias) * 100);
  };

  if (loading || !projeto) {
    return (
      <div className="container mt-4 text-center">
        <div className="spinner-border text-primary" role="status"></div>
        <div>Carregando...</div>
      </div>
    );
  }

  // --- O restante do seu código (lógica e JSX) permanece O MESMO ---
  // (Ele já usa os nomes corretos do banco, como 'valor_repasse')

  const valorOrcadoTotal = parseFloat(projeto.valor_repasse) || 0;
  const valorRestante = Math.max(0, valorOrcadoTotal - valorGasto);
  const percentualGasto =
    valorOrcadoTotal > 0
      ? Math.round((valorGasto / valorOrcadoTotal) * 100)
      : 0;

  const etapas = [1, 2, 3, 4, 5, 6].map((n) => {
    const inicio = projeto[`data_inicio_etapa${n}`];
    const fim = projeto[`data_termino_etapa${n}`];
    const situacao = projeto[`situacao_etapa${n}`];
    const prazo = projeto[`prazo_etapa${n}`];

    return {
      nome: `Etapa ${n}`,
      inicio: inicio ? new Date(inicio).toLocaleDateString("pt-BR") : "---",
      fim: fim ? new Date(fim).toLocaleDateString("pt-BR") : "---",
      situacao: situacao,
      prazo: prazo,
      progresso: calcularProgressoEtapa(inicio, fim, situacao),
    };
  });

  let etapaAtual = etapas.find(
    (e) => (e.situacao || "").toLowerCase() !== "concluído"
  );
  if (!etapaAtual) etapaAtual = etapas[etapas.length - 1];

  const progressoEtapaAtual = etapaAtual.progresso;
  const hoje = new Date();
  const dataFimEtapaAtual = new Date(
    projeto[`data_termino_etapa${etapas.indexOf(etapaAtual) + 1}`]
  );

  const etapaAtrasada =
    (etapaAtual.situacao || "").toLowerCase() === "em andamento" &&
    hoje > dataFimEtapaAtual;

  return (
    <div className="container-fluid mt-4" id="dashboard-content">
      {/* Estilos (sem alterações) */}
      <style>{`
        #dashboard-content {
          max-width: 1600px;
          margin: auto;
        }
        .dashboard-card { 
          margin-bottom: 20px; 
          box-shadow: 0 4px 12px rgba(0,0,0,0.05); 
          border: none; 
          border-radius: 10px; 
          height: 100%;
        }
        .dashboard-card .card-body { padding: 1.5rem; }
        .dashboard-card .card-title { font-weight: 600; color: #34495e; margin-bottom: 1.2rem; }
        .back-btn { 
          background-color: #f4f7f6; 
          border: 1px solid #ddd; 
          color: #333; 
        }
        .back-btn:hover {
          background-color: #e9ecef;
        }
      `}</style>

      {/* Header (sem alterações) */}
      <div className="row mb-4">
        <div className="col-12 d-flex justify-content-between align-items-center flex-wrap">
          <h2 className="mb-1" style={{ color: "#2c3e50", fontWeight: "bold" }}>
            Estatísticas: {projeto.nomeprojeto}
          </h2>
          <Link to={`/viewprojetocompleto/${id}`} className="btn back-btn">
            <i className="fas fa-arrow-left"></i> Voltar ao Projeto
          </Link>
        </div>
      </div>

      <div className="row">
        {/* Card: Gasto X Orçado (sem alterações) */}
        <div className="col-md-4 mb-3">
          <div className="card dashboard-card h-100">
            <div className="card-body">
              <h5 className="card-title">Gasto X Orçado</h5>
              <p>
                <strong>Orçado (Repasse):</strong> R${" "}
                {valorOrcadoTotal.toLocaleString("pt-BR", {
                  minimumFractionDigits: 2,
                })}
              </p>
              <p>
                <strong>Gasto (Cronograma):</strong> R${" "}
                {valorGasto.toLocaleString("pt-BR", {
                  minimumFractionDigits: 2,
                })}
              </p>
              <p>
                <strong>Restante:</strong> R${" "}
                {valorRestante.toLocaleString("pt-BR", {
                  minimumFractionDigits: 2,
                })}
              </p>
              <div className="progress">
                <div
                  className="progress-bar bg-success "
                  style={{ width: `${percentualGasto}%` }}
                  role="progressbar"
                  aria-valuenow={percentualGasto}
                  aria-valuemin="0"
                  aria-valuemax="100"
                >
                  {percentualGasto > 15 ? `${percentualGasto}%` : ""}
                </div>
              </div>
              <small className="text-muted">
                {percentualGasto}% do orçamento utilizado
              </small>
            </div>
          </div>
        </div>

        {/* Card: Progresso da Etapa (sem alterações) */}
        <div className="col-md-4 mb-3">
          <div className="card dashboard-card h-100">
            <div className="card-body">
              <h5 className="card-title">
                Progresso da Etapa Atual: {etapaAtual.nome}
              </h5>
              <p>
                <strong>Início:</strong> {etapaAtual.inicio}
              </p>
              <p>
                <strong>Fim:</strong> {etapaAtual.fim}
              </p>
              <div className="progress">
                <div
                  className={`progress-bar ${
                    etapaAtrasada ? "bg-danger" : "bg-primary"
                  }`}
                  style={{ width: `${progressoEtapaAtual}%` }}
                  role="progressbar"
                  aria-valuenow={progressoEtapaAtual}
                  aria-valuemin="0"
                  aria-valuemax="100"
                >
                  {progressoEtapaAtual > 15 ? `${progressoEtapaAtual}%` : ""}
                </div>
              </div>
              <small className="text-muted">
                {progressoEtapaAtual}% do tempo da etapa utilizado
              </small>
              {etapaAtrasada && (
                <div className="text-danger fw-bold mt-2">Etapa atrasada!</div>
              )}
              {!etapaAtrasada && (
                <div className="text-muted mt-2">
                  Situação: {etapaAtual.situacao || "Não iniciado"}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Card: Resumo das Etapas (sem alterações) */}
        <div className="col-md-4 mb-3">
          <div className="card dashboard-card h-100">
            <div className="card-body">
              <h5 className="card-title">Resumo das Etapas</h5>
              <ul className="list-group list-group-flush">
                {etapas.map((etapa, idx) => (
                  <li
                    key={idx}
                    className="list-group-item d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <strong>{etapa.nome}:</strong> {etapa.situacao || "---"}
                      <br />
                      <small className="text-muted">
                        {etapa.inicio} até {etapa.fim}
                      </small>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EstatisticasProjeto;
